const logo = require('../../assets/images/sarah-sad-01.png');

export default function LoadingScreen() {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-beige">
      <img
        src={logo}
        alt="logo"
        className="animate-pulse h-64"
      />
    </div>
  );
}
